import { render, staticRenderFns } from "./FilterClient.vue?vue&type=template&id=810c643e&scoped=true&"
import script from "./FilterClient.vue?vue&type=script&lang=js&"
export * from "./FilterClient.vue?vue&type=script&lang=js&"
import style0 from "./FilterClient.vue?vue&type=style&index=0&id=810c643e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "810c643e",
  null
  
)

export default component.exports